import { render, staticRenderFns } from "./Samo.vue?vue&type=template&id=9b4e31e8&scoped=true&"
import script from "./Samo.vue?vue&type=script&lang=js&"
export * from "./Samo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4e31e8",
  null
  
)

export default component.exports